(() => {
  const checkboxSelector = "#cartAgreementCheckbox";
  const checkoutSelector = "#CartDrawer-Checkout";
  const errorSelector = ".cart-agreement-error";

  function getAgreementRoot(element = document) {
    return element.closest?.(".wt-cart__footer__body") || document;
  }

  function syncCheckoutState(root = document) {
    const checkbox = root.querySelector(checkboxSelector);
    const checkoutButton = root.querySelector(checkoutSelector);
    if (!checkbox || !checkoutButton) return;

    checkoutButton.disabled = !checkbox.checked;
    checkoutButton.classList.toggle("disabled", !checkbox.checked);

    if (checkbox.checked) {
      const errorMessage = root.querySelector(errorSelector);
      if (errorMessage) errorMessage.style.display = "none";
    }
  }

  function handleAgreementChange(event) {
    if (!event.target.matches?.(checkboxSelector)) return;

    syncCheckoutState(getAgreementRoot(event.target));
  }

  function handleCheckoutClick(event) {
    const checkoutButton = event.target.closest?.(checkoutSelector);
    if (!checkoutButton) return;

    const root = getAgreementRoot(checkoutButton);
    const checkbox = root.querySelector(checkboxSelector);
    const errorMessage = root.querySelector(errorSelector);

    if (checkbox && !checkbox.checked) {
      event.preventDefault();
      if (errorMessage) errorMessage.style.display = "block";
    }
  }

  function resetAgreement() {
    document.querySelectorAll(".wt-cart__footer__body").forEach((root) => {
      const checkbox = root.querySelector(checkboxSelector);
      if (checkbox) checkbox.checked = false;
      syncCheckoutState(root);
    });
  }

  document.addEventListener("change", handleAgreementChange);
  document.addEventListener("input", handleAgreementChange);
  document.addEventListener("click", handleCheckoutClick);
  document.addEventListener("DOMContentLoaded", resetAgreement);
  window.addEventListener("pageshow", resetAgreement);
})();
